import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { toast } from "react-toastify";
import { axios } from "../utils/axios";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

export const getAgentes = async () => {
  try {
    handlerLoading({ loading: true, loadName: "agentes" });
    const result = await axios().get("interacciones_agentes");

    const { data, error } = result.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    if (data) {
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "agentes" });
  }
};

export const getAgente = async (payload) => {
  try {
    if (payload?.nivel == "anio") {
      handlerLoading({ loading: true, loadName: "agente" });
    } else {
      handlerLoading({ loading: true, loadName: "agente_dias" });
    }
    const result = await axios().post("interacciones_un_agente", payload);

    const { data, error } = result.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    if (data) {
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    if (payload?.nivel == "anio") {
      handlerLoading({ loading: false, loadName: "agente" });
    } else {
      handlerLoading({ loading: false, loadName: "agente_dias" });
    }
  }
};
